import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";

const {ccclass, property} = cc._decorator;

@ccclass
export default class firstRankPage extends cc.Component {

    @property({type:cc.RichText,displayName:"decLabel"})
    decLabel:cc.RichText = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lb_name:cc.Label = null;

    @property({type:cc.Node,displayName:"头像节点"})
    headNode:cc.Node = null;

    onLoad(){
        this.node.zIndex = 100;
    }

    closeFun:()=>void = null;
    
    bindData(userName:string,headUrl:string,score:number,closeFun:()=>void){
        this.lb_name.string = userName;
        O1HD.getServices().miniGameSrv.getAppApiInstance().drawUrlImage(headUrl,(spf=>{
            this.headNode.getComponent(cc.Sprite).spriteFrame = spf;
        }));
        this.decLabel.string = `<color=#2A2A2A>恭喜</c><color=#CB5F4A>${userName}</c><color=#2A2A2A>以</c><color=#CB5F4A>${data_control.getNumberFormat(score)}</c><color=#2A2A2A>成功登顶，成为世界首富</c>`;
        this.closeFun = closeFun;
    }

    onBtnClose(){
        this.closeFun && this.closeFun();
        this.node.destroy();
        this.node.removeFromParent();
    }

}
